// extracted by mini-css-extract-plugin
module.exports = {"popupText":"style_popupText_3dovG","btnWrapp":"style_btnWrapp_5v4nj","btn":"style_btn_3VtJ5"};